import React, { useState, useEffect } from 'react';

import 'moment/locale/es';
import { trackPromise } from 'react-promise-tracker';
import { usePromiseTracker } from 'react-promise-tracker';
import TextField from '@material-ui/core/TextField';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import SearchIcon from '@material-ui/icons/Search';
import 'survey-core/defaultV2.css';
import './AccessForm.scss';

import {
  Button,
  Grid,
  MenuItem,
  Typography,

} from '@material-ui/core';
import LoadingLockPage from '../ShareComponents/LoadingLockPage';
import ErrorModal from '../ShareComponents/ErrorModal';
import Validations from '../../helpers/Validations';
import { IDataAccess } from '../../interfaces/IDataAccess';
import { getCAMPUS_FACULTIES, getCITY, getCOUNTRIES_CITIES, getDEPARTAMENT, getPROGRAMS } from '../../services/ParameterService';
import { IGeneralParameter } from '../../interfaces/IGeneralParameter';
import { sortByKey } from '../../helpers/sharedFunctions';
import { IListParametersInfo } from '../../interfaces/IListParametersInfo';
import { getResourceAccess, registerVisit } from '../../services/ResourceServices';
import { IGraduateInfo } from '../../interfaces/IGraduateInfo';

const initialFormValues = {
  doc: '',
  name: '',
  surname: '',
  cellphone: '',
  email: '',
  residenceCountry: '',
  residenceDepartment: '',
  residenceCity: '',
  campus: '',
  school: '',
  program: '',

};

const formValidations = {
  doc: {
    error: '',
    validate: 'number',
    minLength: 4,
    required: true
  },
  name: {
    error: '',
    validate: 'textNumber',
    minLength: 4,
    required: true
  },
  surname: {
    error: '',
    validate: 'textNumber',
    minLength: 4,
    required: true
  },
  cellphone: {
    error: '',
    validate: 'number',
    minLength: 4,
    required: true
  },
  email: {
    error: '',
    validate: 'email',
    minLength: 4,
    required: true
  },  
  residenceCountry: {
    error: '',
    validate: 'textNumber',
    minLength: 4,
    required: true
  },
  residenceDepartment: {
    error: '',
    validate: 'textNumber',
    minLength: 4,
    required: true
  },
  residenceCity: {
    error: '',
    validate: 'textNumber',
    minLength: 4,
    required: true
  },
  campus: {
    error: '',
    validate: 'textNumber',
    minLength: 1,
    required: false
  },
  school: {
    error: '',
    validate: 'textNumber',
    minLength: 1,
    required: false
  },
  program: {
    error: '',
    validate: 'textNumber',
    minLength: 1,
    required: false
  },
};


interface ResourceFormProps {
  action?: string;
  backActionOverride?: any;
  afterUpdateAction?: any
  idResource: number
}

const ResourceForm: React.FC<ResourceFormProps> = ({ backActionOverride, afterUpdateAction, idResource }) => {
  const { promiseInProgress } = usePromiseTracker();
  const [formValues, setFormValues] = useState(new IDataAccess({}));
  const [formErrors, setFormErrors] = useState(initialFormValues);
  const [countryCitiesArray, setCountryCitiesArray] = useState<Array<IListParametersInfo>>([]);
  const [departmentArray, setDepartmentArray] = useState<Array<IGeneralParameter>>([]);
  const [cityArray, setCityArray] = useState<Array<IGeneralParameter>>([]);
  const [cities, setCities] = useState<Array<IGeneralParameter>>([]);
  const [allCampus, setAllCampus] = useState<Array<IListParametersInfo>>([]);
  const [schools, setSchools] = useState<Array<IGeneralParameter>>([]);
  const [allPrograms, setAllPrograms] = useState<Array<IGeneralParameter>>([]);
  const [programs, setPrograms] = useState<Array<IGeneralParameter>>([]);
  const [initialValues, setInitialValues] = useState<boolean>(true);
  const [isGraduated, setIsGraduated] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [openModalError, setOpenModalError] = useState(false);
  const [showFields, setShowFields] = useState(false);


  const isValid = showFields && parseInt(formValues.doc) > 1000 && formValues.name.length > 0 && formValues.surname.length > 0 && formValues.cellphone > 0 && formValues.email.length > 0 &&
    (formValues.residenceCountry === 170 ? (formValues.residenceCountry > 0 && formValues.residenceDepartment > 0 && formValues.residenceCity > 0) : formValues.residenceCountry > 0) &&
    (isGraduated ? (formValues.campus > 0 && formValues.school > 0 && formValues.program > 0) : true);

  const isValidSearch = parseInt(formValues.doc) > 1000;


  useEffect(() => {

    const getInitialdata = async () => {
      // data countries-cities
      const getInfo: any = await trackPromise(getCOUNTRIES_CITIES());
      let resultList: Array<IListParametersInfo> = getInfo.list;
      let dataCountryCities: Array<IListParametersInfo>;
      dataCountryCities = sortByKey(resultList, 'grandParentName');
      setCountryCitiesArray(dataCountryCities);
      // department field
      const getInfoDep: any = await trackPromise(getDEPARTAMENT());
      let resultListDep: Array<IGeneralParameter> = getInfoDep;
      let responseDepartment = sortByKey(resultListDep, 'name');
      setDepartmentArray(responseDepartment);
      // city field
      const getInfoCity: any = await trackPromise(getCITY());
      let resultListCity: Array<IGeneralParameter> = getInfoCity;
      let responseCity = sortByKey(resultListCity, 'name');
      setCityArray(responseCity);
      //campus field
      const getInfoCampus: any = await trackPromise(getCAMPUS_FACULTIES());
      let dataAllCampus: Array<IListParametersInfo> = getInfoCampus.list;
      dataAllCampus = sortByKey(dataAllCampus, 'parentName');
      setAllCampus(dataAllCampus ? dataAllCampus : []);
      //program field
      const getInfoPograms: any = await trackPromise(getPROGRAMS());
      let dataAllPrograms: Array<IGeneralParameter> = getInfoPograms;
      dataAllPrograms = sortByKey(dataAllPrograms, 'parentName');
      setAllPrograms(dataAllPrograms);

      setInitialValues(false);
    }
    getInitialdata();


  }, []);


  useEffect(() => {
    if (!initialValues) {
      setFormValues(prev => ({
        ...prev,
        department: 0,
        city: 0
      }));

    }

    if (formValues.residenceCountry > 0) {
      if (formValues.residenceCountry === 170) {
        setCities([]);
      } else {
        const countryObjSelected = countryCitiesArray.find(country => country.id === formValues.residenceCountry);
        if (countryObjSelected) {
          setCities(countryObjSelected.childs);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValues.residenceCountry])


  useEffect(() => {
    setSchools([]);
    setPrograms([]);
    setFormValues(prev => ({
      ...prev,
      doc: sessionStorage.getItem('doc') || "",
    }));
    if (formValues.campus > 0) {
      const campusFound = allCampus.find(campus => campus.id === formValues.campus);
      if (campusFound) {
        const campus: IListParametersInfo = campusFound;
        let schools = campus.childs;
        schools = sortByKey(schools, 'name');
        setSchools(schools);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValues.campus])

  useEffect(() => {

    const getPrograms = async () => {
      setPrograms([]);
      setFormValues(prev => ({
        ...prev
      }))

      if (formValues.school > 0) {
        let programsBySchool = allPrograms.filter(item => item.parentId === formValues.school);
        programsBySchool = sortByKey(programsBySchool, 'name');
        setPrograms(programsBySchool ? programsBySchool : [])
      }
    }
    getPrograms();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValues.school])


  useEffect(() => {
    if (!initialValues) {
      setFormValues(prev => ({
        ...prev,
        city: 0

      }));
    }
    if (formValues.residenceDepartment > 0) {
      let citiesDep: Array<IGeneralParameter> = cityArray.filter(city => city.parentId === formValues.residenceDepartment);
      citiesDep = sortByKey(citiesDep, 'name');
      if (citiesDep.length > 0) {
        setCities(citiesDep)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValues.residenceDepartment])

  useEffect(() => {
    if (formValues.residenceCountry !== (0 || 170)) {
      setFormValues(prev => ({
        ...prev,
        department: 0,
        city: 0
      }));
    }
  }, [formValues.residenceCity, formValues.residenceDepartment])

  const getAccess = async () => {
    const parameterToSend: object = { documentId: formValues.doc, publishingId: idResource };
    const getInfo: any = await trackPromise(getResourceAccess(parameterToSend));

    if (getInfo.status === 200) {
      sessionStorage.setItem('doc', formValues.doc.toString());
      let resultInfo: IGraduateInfo = await getInfo.json();

      if (resultInfo.userExist) {
        afterUpdateAction();
      } else {

        setIsGraduated(resultInfo.isGraduated);
        const formData: IDataAccess = new IDataAccess({
          doc: formValues.doc,
          name: resultInfo.info.names,
          surname: resultInfo.info.surname,
          cellphone: resultInfo.info.cellphone,
          email: resultInfo.info.email,
          residenceCountry: resultInfo.info.residenceCountry,
          residenceDepartment: resultInfo.info.residenceDepartment,
          residenceCity: resultInfo.info.residenceCity,
          campus: resultInfo.info?.educationUnal?.campus,
          school: resultInfo.info?.educationUnal?.school,
          program: resultInfo.info?.educationUnal?.curriculum,
          isGraduated: resultInfo.isGraduated
        });

        setFormValues(prev => ({
          ...prev,
          residenceCountry: formData.residenceCountry
        }));

        setFormValues(prev => ({
          ...prev,
          residenceCountry: formData.residenceCountry,
          residenceDepartment: formData.residenceDepartment,
          residenceCity: formData.residenceCity,
          campus: formData.campus,
          school: formData.school,
          program: formData.program,
          isGraduate: formData.isGraduated
        }));


        setFormValues(formData);
      }
    } else {
      setErrorMessage("Hubo un error, intente de nuevo mas tarde");
      setOpenModalError(true);
    }
  }

  const findDocument = () => {
    getAccess().then(() => {
      setShowFields(true);
    });

  };


  const saveVisitor = async () => {
    const responseCSF: any = await trackPromise(registerVisit(formValues));

    if (responseCSF.status === 200) {
      const result = await responseCSF.json();
      getAccess();
      setOpenModalError(false);
      afterUpdateAction();
    } else {
      setErrorMessage("Hubo un error, intente de nuevo mas tarde");
      setOpenModalError(true);
    }
  }


  const handleCloseModalError = () => {
    setOpenModalError(false);
    backActionOverride();
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: value
    }));

    const error = Validations(name, value, formValidations) || '';
    setFormErrors((prev) => ({
      ...prev,
      [name]: error
    }));

  };

  return (
    <>


      <Grid container item className="data-form">
        <Grid container item xs={12} className="data-form-container1">
          <Grid container item xs={12} className="title-data-container">
            <Typography variant="h2" className="title">
              Solicitud de Acceso
            </Typography>
          </Grid>

          <Grid container className="event-form-content1">
            <Grid container className="field-box-margin" >
              <Grid item xs={12}>
                <Typography variant="h5" className="field-box-title">Documento*</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  name="doc"
                  placeholder="Numero de documento "
                  rows={1}
                  variant="outlined"
                  value={formValues.doc || ''}
                  onChange={handleChange}
                  error={!!formErrors.doc}
                  helperText={formErrors.doc}
                  margin="none"
                />
              </Grid >
              <Grid container item xs={6} className="buttons-container-search">
                <Button
                  startIcon={<SearchIcon />}
                  className="search-button"
                  variant="contained"
                  size="small"
                  disabled={!isValidSearch}
                  onClick={findDocument}
                >
                  Consultar
                </Button>
              </Grid>
            </Grid>


            {showFields ? (
              <Grid container spacing={1} className="field-box-margin" >
                <Grid item xs={6}>
                  <Typography variant="h5" className="field-box-title">Nombre*</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="h5" className="field-box-title">Apellido*</Typography>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    name="name"
                    placeholder="Nombre"
                    rows={1}
                    variant="outlined"
                    value={formValues.name || ''}
                    onChange={handleChange}
                    error={!!formErrors.name}
                    helperText={formErrors.name}
                    margin="none"
                  />
                </Grid >
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    name="surname"
                    placeholder="Apellido"
                    rows={1}
                    variant="outlined"
                    value={formValues.surname || ''}
                    onChange={handleChange}
                    error={!!formErrors.surname}
                    helperText={formErrors.surname}
                    margin="none"
                  />
                </Grid >
                <Grid item xs={6}>
                  <Typography variant="h5" className="field-box-title">Telefono*</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="h5" className="field-box-title">Correo electrónico*</Typography>
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    name="cellphone"
                    placeholder="Telefono"
                    rows={1}
                    variant="outlined"
                    value={formValues.cellphone || ''}
                    onChange={handleChange}
                    error={!!formErrors.cellphone}
                    helperText={formErrors.cellphone}
                    margin="none"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    name="email"
                    placeholder="Correo electrónico"
                    rows={1}
                    variant="outlined"
                    value={formValues.email || ''}
                    onChange={handleChange}
                    error={!!formErrors.email}
                    helperText={formErrors.email}
                    margin="none"
                  />
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="h5" className="field-box-title">País*</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="h5" className="field-box-title">Departamento*</Typography>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    id="outlined-select-country"
                    select
                    name="residenceCountry"
                    label={formValues.residenceCountry === 0 ? "Seleccione" : ""}
                    value={formValues.residenceCountry === 0 ? "" : formValues.residenceCountry}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: false }}
                    margin="none"
                    variant="outlined"
                  >
                    {
                      countryCitiesArray && countryCitiesArray.length > 0 &&
                      <MenuItem value={0}><em>Ninguno</em></MenuItem>
                    }
                    {countryCitiesArray && countryCitiesArray.length > 0 ?
                      countryCitiesArray.map((option: IListParametersInfo) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.grandParentName}
                        </MenuItem>
                      ))
                      :
                      <MenuItem value={formValues.residenceCountry}></MenuItem>
                    }
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    id="outlined-select-department"
                    select
                    name="residenceDepartment"
                    label={formValues.residenceDepartment === 0 ? "Seleccione" : ""}
                    value={formValues.residenceDepartment === 0 ? 0 : formValues.residenceDepartment}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: false }}
                    disabled={(formValues.residenceCountry > 0 && departmentArray.length > 0 && formValues.residenceCountry === 170 ? false : true)}
                    margin="none"
                    variant="outlined"
                  >
                    {
                      departmentArray.length > 0 ?
                        departmentArray.map((option: IGeneralParameter) => (
                          <MenuItem key={option.parameter_code} value={option.parameter_code}>
                            {option.name}
                          </MenuItem>
                        ))
                        :
                        <MenuItem value={formValues.residenceDepartment}></MenuItem>
                    }
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="h5" className="field-box-title">Ciudad*</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="h5" className="field-box-title">Sede{isGraduated ? '*' : ''}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    id="outlined-select-city"
                    select
                    name="residenceCity"
                    label={formValues.residenceCity === 0 ? "Seleccione" : ""}
                    value={formValues.residenceCity === 0 ? 0 : formValues.residenceCity}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: false }}
                    disabled={(cities && ((formValues.residenceCountry === 170 && formValues.residenceDepartment > 0) || (formValues.residenceCountry !== 170 && formValues.residenceCountry > 0)) ? false : true)}
                    margin="none"
                    variant="outlined"
                  >
                    {
                      cities.length > 0 ?
                        cities.map((option: IGeneralParameter) => (
                          <MenuItem key={option.parameter_code} value={option.parameter_code}>
                            {option.name}
                          </MenuItem>
                        ))
                        :
                        <MenuItem value={formValues.residenceCity}></MenuItem>
                    }
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    id="outlined-select-campus"
                    select
                    name="campus"
                    label={formValues.campus === 0 ? "Seleccione" : ""}
                    value={formValues.campus === 0 ? null : formValues.campus}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: false }}
                    margin="none"
                    variant="outlined"
                  >
                    {
                      allCampus && allCampus.length > 0 ?
                        allCampus.map((option: IListParametersInfo) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.parentName}
                          </MenuItem>
                        ))
                        :
                        <MenuItem value={formValues.campus}></MenuItem>
                    }
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="h5" className="field-box-title">Facultad{isGraduated ? '*' : ''}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="h5" className="field-box-title">Programa{isGraduated ? '*' : ''}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    id="outlined-select-school"
                    select
                    name="school"
                    label={formValues.school === 0 ? "Seleccione" : ""}
                    value={formValues.school === 0 ? null : formValues.school}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: false }}
                    margin="none"
                    variant="outlined"
                    disabled={formValues.campus && formValues.campus > 0 ? false : true}
                  >
                    {
                      formValues.campus && formValues.campus > 0 && schools.length > 0 ?
                        schools.map((option: IGeneralParameter) => (
                          <MenuItem key={option.parameter_code} value={option.parameter_code}>
                            {option.name}
                          </MenuItem>
                        )) :
                        < MenuItem value={formValues.school}></MenuItem>
                    }
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    id="outlined-select-program"
                    select
                    name="program"
                    label={formValues.program === 0 ? "Seleccione" : ""}
                    value={formValues.program === 0 ? null : formValues.program}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: false }}
                    margin="none"
                    variant="outlined"
                    disabled={programs && programs.length > 0 ? false : true}
                  >
                    {
                      programs && programs.length > 0 ?
                        programs.map((option: IGeneralParameter) => (
                          <MenuItem key={option.parameter_code} value={option.parameter_code}>
                            {option.name}
                          </MenuItem>
                        ))
                        :
                        <MenuItem value={formValues.program}></MenuItem>
                    }
                  </TextField>
                </Grid>
              </Grid>) : null

            }
          </Grid>

        </Grid>

      </Grid >


      <Grid container item xs={12} className="buttons-container-data">
        <Grid container item xs={6} className="left-buttons">
          <Button
            startIcon={<ChevronLeftIcon />}
            className="cancel-button"
            variant="contained"
            size="small"
            onClick={backActionOverride}
          >
            Cancelar
          </Button>
        </Grid>
        <Grid container item xs={6} className="right-buttons">
          <Button
            disabled={!isValid}
            onClick={saveVisitor}
            className="save-button"
            variant="contained"
            size="small"
          >
            Guardar
          </Button>
        </Grid>
      </Grid>

      <ErrorModal
        errorMsg={errorMessage}
        handleCloseModal={handleCloseModalError}
        openModalError={openModalError}
      />
      {/* <LoadingLockPage load={initLoad}/> */}
      <LoadingLockPage load={promiseInProgress} />

    </>
  )

};

export default ResourceForm;


